import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";


const AutoLogin: React.FC = () => {
  const { instance } = useMsal();

    const silentLogin = () => {
      instance.loginRedirect({
        scopes: [
          "User.Read",  
          "openid",
          "profile",
          "api://e1cb820d-07a0-43d1-ba40-9fbec2d65688/access_as_user" 
        ]
      });
    /*
      if (accounts.length === 0) {
    }
    */
  }

  //return null; // komponenten renderar inget, den hanterar bara inloggning
  return <button className="sign-out" onClick={silentLogin}>Sign In</button>;
};

export default AutoLogin;

/*
await instance.handleRedirectPromise();

const accounts = instance.getAllAccounts();
if (accounts.length === 0) {
    // No user signed in
    instance.loginRedirect({
        scopes: [
          "User.Read",  
          "openid",
          "profile",
          "api://e1cb820d-07a0-43d1-ba40-9fbec2d65688/access_as_user" 
        ]
      });
}
*/